// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__10-U6","footer":"ModalUpdate_footer__3XBm0"};